import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	heatStatus: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "4px",
		minWidth: "24px",
		height: "24px",
	},
	heatStatusContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "8px",
	},
}));

const heatStatuses: { [key: string]: any } = {
	S: { name: "Scheduled", color: " #0288D1", letter: "S" },
	M: { name: "Melting", color: " #FF7043", letter: "M" },
	T: { name: "Tapped", color: " #D2AF00", letter: "T" },
	O: { name: "Opened", color: " #43A047", letter: "O" },
	C: { name: "Closed", color: " #607D8B", letter: "C" },
	R: { name: "Returned", color: " #8D6E63", letter: "R" },
	F: { name: "Finished", color: " #3F90B5", letter: "F" },
};
export const HeatStatusControl = ({
	heatStatus,
}: {
	heatStatus: string | null;
}) => {
	const classes = useStyles();
	const defaultColor = " #D6D6D6";

	const value = heatStatus ? heatStatuses[heatStatus] : null;
	return (
		<>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<div className={classes.heatStatusContainer}>
						{value ? (
							<>
								<div
									className={classes.heatStatus}
									style={{
										backgroundColor: value.color || defaultColor,
										color: "white",
									}}
								>
									<Typography variant="body2">{value.letter}</Typography>
								</div>
								<Typography>{value.name}</Typography>
							</>
						) : (
							<Typography style={{ color: "red" }}>Unlinked</Typography>
						)}
					</div>
				</Grid>
			</Grid>
		</>
	);
};
